var _metadata, _defs, _clipPath, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhosOnFirstComponent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg89",
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    stroke: "none",
    fill: "none",
    viewBox: "0.0 0.0 348.0 348.0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata95"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs93"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    clipRule: "nonzero",
    d: "m0 0l348.0 0l0 348.0l-348.0 0l0 -348.0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g59",
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5",
    fillRule: "nonzero",
    d: "M 0,0 H 348 V 348 H 0 Z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    fillRule: "nonzero",
    d: "M -6,0 H 342 V 347.9685 H -6 Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    fillRule: "nonzero",
    d: "m 5.07874,5.7758217 h 336.9134 V 343.44512 H 5.07874 Z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    fillRule: "nonzero",
    d: "m 5.07874,5.7758217 h 336.9134 V 343.44512 H 5.07874 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    fillRule: "nonzero",
    d: "m 282.73444,40.553925 v 0 c 0,-8.375591 6.96603,-15.165352 15.55905,-15.165352 v 0 c 4.12653,0 8.08402,1.597773 11.00192,4.441828 2.91788,2.844057 4.55713,6.701422 4.55713,10.723524 v 0 c 0,8.375595 -6.966,15.165356 -15.55905,15.165356 v 0 c -8.59302,0 -15.55905,-6.789761 -15.55905,-15.165356 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    fillRule: "nonzero",
    d: "m 282.73444,40.553925 v 0 c 0,-8.375591 6.96603,-15.165352 15.55905,-15.165352 v 0 c 4.12653,0 8.08402,1.597773 11.00192,4.441828 2.91788,2.844057 4.55713,6.701422 4.55713,10.723524 v 0 c 0,8.375595 -6.966,15.165356 -15.55905,15.165356 v 0 c -8.59302,0 -15.55905,-6.789761 -15.55905,-15.165356 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    fillRule: "nonzero",
    d: "M 34.771652,25.389738 H 267.18112 v 67.55905 H 34.771652 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    fillRule: "nonzero",
    d: "M 34.771652,25.389738 H 267.18112 v 67.55905 H 34.771652 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    fillRule: "nonzero",
    d: "M 34.771652,202.31795 H 141.41733 v 44.81891 H 34.771652 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 1,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    fillRule: "nonzero",
    d: "M 34.771652,125.22639 H 141.41733 v 44.8189 H 34.771652 Z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25",
    fillRule: "nonzero",
    d: "M 34.771652,125.22639 H 141.41733 v 44.8189 H 34.771652 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 1,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27",
    fillRule: "nonzero",
    d: "M 34.771652,270.60397 H 141.41733 v 44.81891 H 34.771652 Z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path29",
    fillRule: "nonzero",
    d: "M 34.771652,270.60397 H 141.41733 v 44.81891 H 34.771652 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 1,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31",
    fillRule: "nonzero",
    d: "m 157.40683,202.31795 h 106.64566 v 44.81891 H 157.40683 Z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33",
    fillRule: "nonzero",
    d: "m 157.40683,202.31795 h 106.64566 v 44.81891 H 157.40683 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 1,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path35",
    fillRule: "nonzero",
    d: "m 157.40683,125.22639 h 106.64566 v 44.8189 H 157.40683 Z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37",
    fillRule: "nonzero",
    d: "m 157.40683,125.22639 h 106.64566 v 44.8189 H 157.40683 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 1,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path39",
    fillRule: "nonzero",
    d: "m 157.40683,270.60397 h 106.64566 v 44.81891 H 157.40683 Z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41",
    fillRule: "nonzero",
    d: "m 157.40683,270.60397 h 106.64566 v 44.81891 H 157.40683 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 1,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43",
    fillRule: "nonzero",
    d: "m 277.46194,106.3832 h 52.66141 v 209.03937 h -52.66141 z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path45",
    fillRule: "nonzero",
    d: "m 277.46194,106.3832 h 52.66141 v 209.03937 h -52.66141 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path47",
    fillRule: "nonzero",
    d: "m 290.06036,245.11285 h 27.46457 v 16.47244 h -27.46457 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path49",
    fillRule: "nonzero",
    d: "m 290.06036,245.11285 h 27.46457 v 16.47244 h -27.46457 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path51",
    fillRule: "nonzero",
    d: "m 290.06036,208.9029 h 27.46457 v 16.47243 h -27.46457 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path53",
    fillRule: "nonzero",
    d: "m 290.06036,208.9029 h 27.46457 v 16.47243 h -27.46457 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path55",
    fillRule: "nonzero",
    d: "m 290.06036,281.32285 h 27.46457 v 16.47244 h -27.46457 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path57",
    fillRule: "nonzero",
    d: "m 290.06036,281.32285 h 27.46457 v 16.47244 h -27.46457 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: 32,
      fontFamily: "'DejaVu Sans', sans-serif",
      textAnchor: "middle",
      fill: "#ffffff"
    },
    id: "text63",
    "aria-label": "[ DISPLAY ]"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path97",
    d: "m 64.46875,45.6875 h 6.625 v 2.234375 h -3.75 v 24.0625 h 3.75 v 2.234375 h -6.625 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path99",
    d: "M 90.703125,49.265625 V 67.40625 h 3.8125 q 4.828125,0 7.062505,-2.1875 2.25,-2.1875 2.25,-6.90625 0,-4.6875 -2.25,-6.859375 -2.23438,-2.1875 -7.062505,-2.1875 z m -3.15625,-2.59375 h 6.484375 q 6.78125,0 9.95313,2.828125 3.17187,2.8125 3.17187,8.8125 0,6.03125 -3.1875,8.859375 Q 100.78125,70 94.03125,70 h -6.484375 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path101",
    d: "m 112.17188,46.671875 h 3.15625 V 70 h -3.15625 z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path103",
    d: "m 135.59375,47.4375 v 3.078125 q -1.79688,-0.859375 -3.39063,-1.28125 -1.59375,-0.421875 -3.07812,-0.421875 -2.57812,0 -3.98437,1 -1.39063,1 -1.39063,2.84375 0,1.546875 0.92188,2.34375 0.9375,0.78125 3.53124,1.265625 l 1.90625,0.390625 q 3.53125,0.671875 5.20313,2.375 1.6875,1.6875 1.6875,4.53125 0,3.390625 -2.28125,5.140625 -2.26563,1.75 -6.65625,1.75 -1.65625,0 -3.53125,-0.375 -1.85937,-0.375 -3.85937,-1.109375 v -3.25 q 1.92187,1.078125 3.76562,1.625 1.84375,0.546875 3.625,0.546875 2.70312,0 4.17187,-1.0625 1.46875,-1.0625 1.46875,-3.03125 0,-1.71875 -1.0625,-2.6875 -1.04687,-0.96875 -3.45312,-1.453125 l -1.92187,-0.375 q -3.53125,-0.703125 -5.10938,-2.203125 -1.57812,-1.5 -1.57812,-4.171875 0,-3.09375 2.17187,-4.875 2.1875,-1.78125 6.01562,-1.78125 1.64063,0 3.34375,0.296875 1.70313,0.296875 3.48438,0.890625 z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path105",
    d: "m 145.07812,49.265625 v 8.765625 h 3.96875 q 2.20313,0 3.40625,-1.140625 1.20313,-1.140625 1.20313,-3.25 0,-2.09375 -1.20313,-3.234375 -1.20312,-1.140625 -3.40625,-1.140625 z m -3.15625,-2.59375 h 7.125 q 3.92188,0 5.92188,1.78125 2.01562,1.765625 2.01562,5.1875 0,3.453125 -2.01562,5.21875 -2,1.765625 -5.92188,1.765625 h -3.96875 V 70 h -3.15625 z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path107",
    d: "m 161.23437,46.671875 h 3.15625 V 67.34375 H 175.75 V 70 h -14.51563 z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path109",
    d: "m 187.59375,49.78125 -4.28125,11.609375 h 8.57812 z m -1.78125,-3.109375 h 3.57812 L 198.28125,70 H 195 l -2.125,-5.984375 H 182.35937 L 180.23437,70 h -3.32812 z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path111",
    d: "m 195.96875,46.671875 h 3.39062 l 6.46875,9.59375 6.42188,-9.59375 h 3.39062 l -8.25,12.21875 V 70 h -3.17187 V 58.890625 Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path113",
    d: "m 235.51562,45.6875 v 28.53125 h -6.625 v -2.234375 h 3.73438 v -24.0625 h -3.73438 V 45.6875 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: 20,
      fontFamily: "'DejaVu Sans', sans-serif",
      textAnchor: "middle",
      fill: "#000000"
    },
    id: "text67",
    "aria-label": "[ TEXT ]"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path116",
    d: "m 49.304687,138.80469 h 4.140625 v 1.39648 h -2.34375 v 15.03906 h 2.34375 v 1.39649 h -4.140625 z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path118",
    d: "m 61.707031,139.41992 h 12.333985 v 1.66016 H 68.865234 V 154 h -1.982422 v -12.91992 h -5.175781 z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path120",
    d: "m 75.955078,139.41992 h 9.21875 v 1.66016 h -7.246094 v 4.3164 h 6.94336 v 1.66016 h -6.94336 v 5.2832 h 7.421875 V 154 h -9.394531 z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path122",
    d: "m 87.908203,139.41992 h 2.119141 l 3.623047,5.41992 3.642578,-5.41992 h 2.11914 l -4.6875,7.00195 5,7.57813 h -2.11914 L 93.503906,147.79883 89.373047,154 h -2.128906 l 5.205078,-7.7832 z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "path124",
    d: "M 99.949219,139.41992 H 112.2832 v 1.66016 h -5.17578 V 154 H 105.125 v -12.91992 h -5.175781 z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "path126",
    d: "m 124.68555,138.80469 v 17.83203 h -4.14063 v -1.39649 h 2.33399 v -15.03906 h -2.33399 v -1.39648 z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: 20,
      fontFamily: "'DejaVu Sans', sans-serif",
      textAnchor: "middle",
      fill: "#000000"
    },
    id: "text71",
    "aria-label": "[ TEXT ]"
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "path129",
    d: "m 49.304687,215.80469 h 4.140625 v 1.39648 h -2.34375 v 15.03906 h 2.34375 v 1.39649 h -4.140625 z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "path131",
    d: "m 61.707031,216.41992 h 12.333985 v 1.66016 H 68.865234 V 231 h -1.982422 v -12.91992 h -5.175781 z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "path133",
    d: "m 75.955078,216.41992 h 9.21875 v 1.66016 h -7.246094 v 4.3164 h 6.94336 v 1.66016 h -6.94336 v 5.2832 h 7.421875 V 231 h -9.394531 z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "path135",
    d: "m 87.908203,216.41992 h 2.119141 l 3.623047,5.41992 3.642578,-5.41992 h 2.11914 l -4.6875,7.00195 5,7.57813 h -2.11914 L 93.503906,224.79883 89.373047,231 h -2.128906 l 5.205078,-7.7832 z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "path137",
    d: "M 99.949219,216.41992 H 112.2832 v 1.66016 h -5.17578 V 231 H 105.125 v -12.91992 h -5.175781 z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "path139",
    d: "m 124.68555,215.80469 v 17.83203 h -4.14063 v -1.39649 h 2.33399 v -15.03906 h -2.33399 v -1.39648 z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: 20,
      fontFamily: "'DejaVu Sans', sans-serif",
      textAnchor: "middle",
      fill: "#000000"
    },
    id: "text75",
    "aria-label": "[ TEXT ]"
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "path142",
    d: "m 49.304687,283.80469 h 4.140625 v 1.39648 h -2.34375 v 15.03906 h 2.34375 v 1.39649 h -4.140625 z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "path144",
    d: "m 61.707031,284.41992 h 12.333985 v 1.66016 H 68.865234 V 299 h -1.982422 v -12.91992 h -5.175781 z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "path146",
    d: "m 75.955078,284.41992 h 9.21875 v 1.66016 h -7.246094 v 4.3164 h 6.94336 v 1.66016 h -6.94336 v 5.2832 h 7.421875 V 299 h -9.394531 z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "path148",
    d: "m 87.908203,284.41992 h 2.119141 l 3.623047,5.41992 3.642578,-5.41992 h 2.11914 l -4.6875,7.00195 5,7.57813 h -2.11914 L 93.503906,292.79883 89.373047,299 h -2.128906 l 5.205078,-7.7832 z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "path150",
    d: "M 99.949219,284.41992 H 112.2832 v 1.66016 h -5.17578 V 299 H 105.125 v -12.91992 h -5.175781 z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "path152",
    d: "m 124.68555,283.80469 v 17.83203 h -4.14063 v -1.39649 h 2.33399 v -15.03906 h -2.33399 v -1.39648 z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: 20,
      fontFamily: "'DejaVu Sans', sans-serif",
      textAnchor: "middle",
      fill: "#000000"
    },
    id: "text79",
    "aria-label": "[ TEXT ]"
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "path155",
    d: "m 172.30469,138.80469 h 4.14062 v 1.39648 h -2.34375 v 15.03906 h 2.34375 v 1.39649 h -4.14062 z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "path157",
    d: "m 184.70703,139.41992 h 12.33399 v 1.66016 h -5.17579 V 154 h -1.98242 v -12.91992 h -5.17578 z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "path159",
    d: "m 198.95508,139.41992 h 9.21875 v 1.66016 h -7.2461 v 4.3164 h 6.94336 v 1.66016 h -6.94336 v 5.2832 h 7.42188 V 154 h -9.39453 z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "path161",
    d: "m 210.9082,139.41992 h 2.11914 l 3.62305,5.41992 3.64258,-5.41992 h 2.11914 l -4.6875,7.00195 5,7.57813 h -2.11914 L 216.50391,147.79883 212.37305,154 h -2.12891 l 5.20508,-7.7832 z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "path163",
    d: "m 222.94922,139.41992 h 12.33398 v 1.66016 h -5.17578 V 154 H 228.125 v -12.91992 h -5.17578 z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "path165",
    d: "m 247.68555,138.80469 v 17.83203 h -4.14063 v -1.39649 h 2.33399 v -15.03906 h -2.33399 v -1.39648 z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: 20,
      fontFamily: "'DejaVu Sans', sans-serif",
      textAnchor: "middle",
      fill: "#000000"
    },
    id: "text83",
    "aria-label": "[ TEXT ]"
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "path168",
    d: "m 172.30469,215.80469 h 4.14062 v 1.39648 h -2.34375 v 15.03906 h 2.34375 v 1.39649 h -4.14062 z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "path170",
    d: "m 184.70703,216.41992 h 12.33399 v 1.66016 h -5.17579 V 231 h -1.98242 v -12.91992 h -5.17578 z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "path172",
    d: "m 198.95508,216.41992 h 9.21875 v 1.66016 h -7.2461 v 4.3164 h 6.94336 v 1.66016 h -6.94336 v 5.2832 h 7.42188 V 231 h -9.39453 z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "path174",
    d: "m 210.9082,216.41992 h 2.11914 l 3.62305,5.41992 3.64258,-5.41992 h 2.11914 l -4.6875,7.00195 5,7.57813 h -2.11914 L 216.50391,224.79883 212.37305,231 h -2.12891 l 5.20508,-7.7832 z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "path176",
    d: "m 222.94922,216.41992 h 12.33398 v 1.66016 h -5.17578 V 231 H 228.125 v -12.91992 h -5.17578 z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "path178",
    d: "m 247.68555,215.80469 v 17.83203 h -4.14063 v -1.39649 h 2.33399 v -15.03906 h -2.33399 v -1.39648 z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: 20,
      fontFamily: "'DejaVu Sans', sans-serif",
      textAnchor: "middle",
      fill: "#000000"
    },
    id: "text87",
    "aria-label": "[ TEXT ]"
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "path181",
    d: "m 172.30469,283.80469 h 4.14062 v 1.39648 h -2.34375 v 15.03906 h 2.34375 v 1.39649 h -4.14062 z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "path183",
    d: "m 184.70703,284.41992 h 12.33399 v 1.66016 h -5.17579 V 299 h -1.98242 v -12.91992 h -5.17578 z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "path185",
    d: "m 198.95508,284.41992 h 9.21875 v 1.66016 h -7.2461 v 4.3164 h 6.94336 v 1.66016 h -6.94336 v 5.2832 h 7.42188 V 299 h -9.39453 z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "path187",
    d: "m 210.9082,284.41992 h 2.11914 l 3.62305,5.41992 3.64258,-5.41992 h 2.11914 l -4.6875,7.00195 5,7.57813 h -2.11914 L 216.50391,292.79883 212.37305,299 h -2.12891 l 5.20508,-7.7832 z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "path189",
    d: "m 222.94922,284.41992 h 12.33398 v 1.66016 h -5.17578 V 299 H 228.125 v -12.91992 h -5.17578 z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "path191",
    d: "m 247.68555,283.80469 v 17.83203 h -4.14063 v -1.39649 h 2.33399 v -15.03906 h -2.33399 v -1.39648 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhosOnFirstComponent);
export default __webpack_public_path__ + "static/media/WhosOnFirstComponent.46563ce72551fbc93d789d5a9232bad2.svg";
export { ForwardRef as ReactComponent };